import Set0 from 'data/cards/set-00';
import Set1 from 'data/cards/set-01';
import Set2 from 'data/cards/set-02';
import Set3 from 'data/cards/set-03';
import Set4 from 'data/cards/set-04';

export default [...Set0, ...Set1, ...Set2, ...Set3, ...Set4];
